{
  "back": "Muri",
  "bookmarksMenu": "Tahua",
  "change": "Hurihia",
  "closeBookmarksMenu": "Katia te tahua",
  "closeDialog": "Katia",
  "colonoscopy": "mātai kōpū (colonoscopy)",
  "continue": "Haere tonu",
  "details": "Ngā Taipitopito",
  "errors": {
    "invalidOtp": {
      "details": "<ul>  \n<li>Tirohia mēnā he hē te tuhituhi, ā, ngana anō.</li>  \n<li>Mēnā kei te raru koe, waea mai ki a mātou i {{phone}} (pēhia te Kōwhiringa 2).</li>  \n</ul>",
      "title": "Kāore tērā i hāngai ki ā mātou pūkete"
    },
    "serverErrorOtp": {
      "details": "<ul>  \n<li>Tērā pea he tika ō taipitopito – engari kāore i taea te manatoko i tēnei wā.</li>  \n<li>Tatari mō tētahi wā poto, ā, ngana anō.</li>  \n</ul>",
      "title": "I hapa tētahi mea."
    }
  },
  "formattedDate": "{{date}} i te {{time}}",
  "gastroscopy": "mātai puku (gastroscopy)",
  "loading": "Kei te utaina...",
  "next": "Panuku",
  "no": "Kāo",
  "openBookmarksMenu": "Huakina te tahua",
  "optional": "He kōwhiringa",
  "progress": "Kōkiritanga {{progress}}%",
  "selectLanguage": "Kōwhiria te reo",
  "step": {
    "appointment": "Te Wā Tono",
    "details": "Ngā Taipitopito Whaiaro",
    "health-questions": "Ngā Pātai Hauora",
    "history": "Ngā hātepe, pokanga rānei o mua",
    "insurance": "Inihua Hauora",
    "medications": "Ngā Rongoā",
    "preference-questions": "Ngā Pātai Manakohanga",
    "specialist": "Mātanga"
  },
  "videoUnsupported": "Kāore tō pūtirotiro e tautoko ana i te tūtohu ataata.",
  "yes": "Āe",
  "yesTo": "Āe ki",
  "yourProgress": "Tō kokiritanga"
}
